import React,{useState,useEffect} from "react";
import { Button, message, Checkbox, Modal } from "antd";
import { handleReleaseAllSeats } from './release-all-seats.module';
import { isValid, isValidArray,checkActionAllowed } from "../../utils/utilities";
import { ACTION_BLOCK_ALL_TICKETS_ALLOWED, ACTION_PERMANENT_ADMIN_BLOCK_RELEASE, isSharedTripCheck } from './../../utils/constant';
import { fetchSharingActionsForOperator } from './../common-components/search-result-item-card/search-result-item-card.module';
import './release-all-seats.styles.scss';

export const ReleaseAllSeatsComponent = (props) => {

    const{
        selectedSchedule,
        fetchSeats
    }=props;

    const [isPermanentRelease,setIsPermanentRelease] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Shared trip: follow the sharing agent's permissions
    const isSharedTrip = isValid(selectedSchedule)&&isSharedTripCheck(selectedSchedule.operator_code);
    const [sharingActions,setSharingActions] = useState(null);

    useEffect(()=>{
        if(isSharedTrip){
            fetchSharingActionsForOperator(selectedSchedule.operator_code,(actions)=>{
                setSharingActions(actions);
            });
        }
    },[isValid(selectedSchedule)?selectedSchedule.operator_code:null]);

    const checkSeatActionAllowed=(actionName)=>{
        if(isSharedTrip){
            return isValid(sharingActions)&&isValid(sharingActions[actionName]);
        }
        return checkActionAllowed(actionName);
    }

    const onSuccess=()=>{
        fetchSeats(selectedSchedule.trip_route_id);
    }

    const onFailure=()=>{
        message.error("Failed to release seats!")
    }

    const handleOk=()=>{
        if(isValidArray(selectedSchedule)&&isValidArray(selectedSchedule.trip)&&isValid(selectedSchedule.trip.id)){
            let tripId=selectedSchedule.trip.id;
            handleReleaseAllSeats(tripId,selectedSchedule.trip_route_id,isPermanentRelease,onSuccess,onFailure);
        }else{
            message.error("Trip not selected!")
        }
        setIsModalOpen(false);
        setIsPermanentRelease(false);
    }

    const handleCancel=()=>{
        setIsModalOpen(false);
        setIsPermanentRelease(false);
    }

    if(checkSeatActionAllowed(ACTION_BLOCK_ALL_TICKETS_ALLOWED)){
        return (
            <div className="marginTop marginBottom">
                <Button onClick={()=>setIsModalOpen(true)} className="release-all-seats-btn">
                    Release all admin blocked seats
                </Button>
                <Modal visible={isModalOpen} title="Release all seats" onOk={handleOk} onCancel={handleCancel} cancelButtonProps={{className:"exit-btn"}} >
                    <div>
                        <span>Are you sure to release all admin blocked seats?</span>
                        {checkSeatActionAllowed(ACTION_PERMANENT_ADMIN_BLOCK_RELEASE)&&<div style={{ marginTop: '10px' }}>
                            <Checkbox
                                checked={isPermanentRelease}
                                onChange={(e) => setIsPermanentRelease(e.target.checked)}
                            >
                                Permanent release
                            </Checkbox>
                        </div>}
                    </div>
                </Modal>
            </div>
        )
    }else{
        return null
    }
}
